import { render, staticRenderFns } from "./ClientExtendForm.vue?vue&type=template&id=3de006b4&"
import script from "./ClientExtendForm.vue?vue&type=script&lang=js&"
export * from "./ClientExtendForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports